import * as React from 'react';
import { IIconSize } from './types';

export const IconWrapper = ({ children, Height = '24px', Width = '24px' }: IIconSize) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={Width} height={Height} viewBox="0 0 24 24">
            {children}
        </svg>
    );
};
